import React from "react";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Assets/03/recrutetment_log_black.svg";

const Navbar = () => {

  const handleLinkClick = () => {
    // Collapse the menu if it's open
    const navbarCollapse = document.getElementById("mainNavbar");
    if (navbarCollapse.classList.contains("show")) {
      new window.bootstrap.Collapse(navbarCollapse).toggle();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg bg-white">
      <div className="container">
        {/* Mobile: Logo left + Menu icon right */}
        <div className="d-flex d-lg-none w-100 justify-content-between align-items-center">
          <Link className="navbar-brand" to="/" onClick={handleLinkClick}>
            <img src={logo} height="60px" alt="Logo" />
          </Link>
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
          >
            <FiMenu style={{ width: 28, height: 28, rotate: "90deg" }} color="black" />
          </button>
        </div>

        {/* Desktop logo */}
        <Link
          className="navbar-brand d-none d-lg-flex flex-column align-items-start"
          to="/"
        >
          <img src={logo} height="80px" width="auto" alt="Logo" />
        </Link>

        {/* Collapsible menu */}
        <div
          className="collapse navbar-collapse justify-content-between mb-3"
          id="mainNavbar"
        >
          <ul className="navbar-nav mx-auto gap-3">
            {["/", "/about", "/service", "/candidates", "/employers"].map((path, index) => {
              const label = ["Home", "About Us", "Services", "Candidates", "For Employers"][index];
              return (
                <li className="nav-item" key={index}>
                  <Link className="nav-link" to={path} onClick={handleLinkClick}>
                    {label}
                  </Link>
                </li>
              );
            })}
          </ul>

          <div className="contact_btn">
            <Link
              to="/contact-us"
              className="btn-contact"
              style={{ textDecoration: "none", color: "white" }}
              onClick={handleLinkClick}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
